import React, { useEffect, useState } from "react";
import { useReactFlow, getRectOfNodes, getTransformForBounds } from "reactflow";
import { toPng } from "html-to-image";
import { Button, Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";

const DownloadButton = () => {
    const { t } = useTranslation();
    const { getNodes } = useReactFlow();
    const [loading, setLoading] = useState(false);

    // we use useEffect and setTimeout to give the button
    // the ability to change its state to loading
    // for huge graphs as this will block rendering
    useEffect(() => {
        if (loading) {
            setTimeout(() => {
                const element = document.querySelector<HTMLElement>(
                    ".react-flow__viewport"
                );
                // we calculate a transform for the nodes so that all nodes are visible
                // we then overwrite the transform of the `.react-flow__viewport` element
                // with the style option of the html-to-image library
                const nodesBounds = getRectOfNodes(getNodes());
                if (!element) return;
                const imageWidth = element.scrollWidth;
                const imageHeight = element.scrollHeight;
                const transform = getTransformForBounds(
                    nodesBounds,
                    imageWidth,
                    imageHeight,
                    0.5,
                    2
                );

                toPng(element, {
                    backgroundColor: "#fff",
                    width: imageWidth,
                    height: imageHeight,
                    style: {
                        width: imageWidth + "",
                        height: imageHeight + "",
                        transform: `translate(${transform[0]}px, ${transform[1]}px) scale(${transform[2]})`,
                    },
                    cacheBust: true,

                })
                    .then((dataUrl: any) => {
                        const a = document.createElement("a");

                        a.setAttribute("download", "nlp.png");
                        a.setAttribute("href", dataUrl);
                        a.click();
                    })
                    .finally(() => setLoading(false));
            }, 200);
        }
    }, [getNodes, loading]);

    return (
        <Button onClick={() => setLoading(true)} disabled={loading}>
            {loading && <Spinner size="sm" />}{" "}
            {t("nlp.designerTakeScreenshotButton")}
        </Button>
    );
};

export default DownloadButton;
